export const Locales = Object.freeze({
	en: { id: "en", name: "English" },
	es: { id: "es", name: "Español" },
	pt: { id: "pt", name: "Português" },
	zh: { id: "zh", name: "简体中文" }
});
